module.exports = __webpack_public_path__ + "img/acc1.a52e338d.png";